
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/embedded-checkout/cart-button",
      function () {
        return require("private-next-pages/embedded-checkout/cart-button.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/embedded-checkout/cart-button"])
      });
    }
  